<template>
  <div class="form-group-simple"
  :class="{
    'form-group-simple--completed': completed,
    'form-group-simple--error': errors.has('date')}">

    <label :for="id">{{ label }}</label>

    <input
      ref="input"
      type="text"
      v-model="date"
      @input="change"
      :name="name"
      :id="id"
      :placeholder="placeholder"
      @blur="blur">

    <div class="form-group-simple__details">
      <div class="form-group-simple__messages">
        <div class="form-group-simple__error" v-if="errors.has('date') || customError !== ''">{{customError}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Validator } from 'vee-validate'

export default {
  name: 'v-input-date-simple',
  props: {
    autofocus: {
      default: false,
      type: Boolean
    },
    name: {
      default: 'name',
      type: String
    },
    id: {
      default: 'id',
      type: String
    },
    label: {
      default: '',
      type: String
    },
    placeholder: {
      default: 'dd-mm-jjjj',
      type: String
    }
  },
  data () {
    return {
      date: '',
      previousDateLength: 0,
      errors: '',
      completed: false,
      customError: ''
    }
  },
  created () {
    this.validator = new Validator()
    const rule = {
      required: true
    }
    this.validator.attach(
      'date',
      rule,
      { alias: 'Datum' })

    this.$set(this, 'errors', this.validator.errors)
  },
  mounted () {
    if (this.autofocus) {
      this.$refs.input.focus()
    }
  },
  methods: {
    change (event) {
      if (this.date.length === 0) {
        this.validate()
        this.nextValidation()
        return
      }
      // Replace letters from the date value
      this.date = this.date.replace(/[^\0-9]/ig, '')
      // End of input, validate it to see if it is complete
      if (this.date.length > 9 && this.date.length < 11) {
        // Validate date
        this.validator.validate('date', this.date)
        this.nextValidation()
      }
      // Limit the characters to max 10
      if (this.date.length > 10) {
        this.date = this.date.substring(0, 10)
      }
    },
    nextValidation () {
      // If input has no errors
      if (!this.errors.has('date')) {
        if (this.checkDateIsInRange(this.date)) {
          this.customError = ''
          this.completed = true
          // Emit that the next input should get focus
          this.$emit('nextInput')
        } else {
          this.completed = false
          this.customError = 'Datum moet tussen 01-01-1890 en ' + this.getDateTomorrow() + ' liggen.'
        }
      } else {
        this.completed = false
        if(this.date.length === 0) {
          this.customError = "* Dit veld is verplicht."
        } else {
          this.customError = 'De datum moet in het formaat dd-mm-jjjj worden ingevoerd.'
        }
      }
      this.$emit('updateValidation', this.completed)
    },
    validate () {
      this.validator.validate('date', this.date)
    },
    blur (e) {
      // If date is 12122012 format
      if (this.date.length === 8 && this.date.indexOf('-') === -1 && this.date.indexOf('/') === -1 && this.date.indexOf('.') === -1) {
        this.date = this.date.replace(/^(\d{2})(\d{2})/, '$1-$2-')
      }
      // If date is 12.12.2012 format
      if (this.date.indexOf('.') > -1) {
        this.date = this.date.replace(/[.]/g, '-')
      }
      let computedDate = this.date.split('-')
      if (computedDate[0].length > 2) {
        this.customError = 'De datum moet in het formaat dd-mm-jjjj worden ingevoerd.'
        this.completed = false
        return
      }    
      this.validate()
      this.nextValidation()
    },
    checkDateIsInRange (date) {
      if (date.length < 8) {
        return false
      }
      let startDate = moment('1890-01-01', 'YYYY-MM-DD').format('YYYY-MM-DD')
      let endDate = moment().add(1, 'days').format('YYYY-MM-DD')
      if (date.indexOf('/') >= 0) {
        date = moment(date, 'DD/MM/YYYY').format('DD-MM-YYYY')
      }
      if (date.indexOf('.') >= 0) {
        date = moment(date, 'DD.MM.YYYY').format('DD-MM-YYYY')
      }
      if (date.indexOf(' ') >= 0) {
        return false
      }      
      date = date.split('-')
      date = date[2] + '-' + date[1] + '-' + date[0]
      return moment(date, 'YYYY-MM-DD').isBetween(startDate, endDate)
    },
    getDateTomorrow () {
      return moment().add(1, 'days').format('DD-MM-YYYY')
    }
  }
}
</script>
